import PropTypes from 'prop-types'
import React from 'react'
import Modal from 'react-modal'
import {FiX} from 'react-icons/fi'
import { sidebarWidth } from '../../theme/globalTheme'
import './theme'

const PreviewFrame = ({ isOpen = false, picture = '', onClose, sidebarOpen = true }) => {

  return (<Modal
    isOpen={isOpen}
    onRequestClose={onClose}
    style={{
      overlay: {
        position: 'fixed',
        top: 0,
        right: 0,
        bottom: 0,
        left: !sidebarOpen ? `${sidebarWidth}%` : '0px',
      },
      content: {
        width: '95%',
        height: '95%',
        top: 'unset',
        left: 'unset',
        right: 'unset',
        bottom: 'unset',
        overflow: 'hidden'
      }
    }}
  >
      <FiX style={{position: 'absolute', right: '19px', fontSize: '30px', cursor: 'pointer'}} onClick={onClose}/>
    <img width={!sidebarOpen ? `100%` : '100%'} height={"auto"} src={picture} alt={picture}/>
  </Modal>)
}

PreviewFrame.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  picture: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  sidebarOpen: PropTypes.bool.isRequired,
}

export default PreviewFrame



// WEBPACK FOOTER //
// ./src/containers/PreviewFrame/struct.js